import React, { PropTypes } from 'react';
import { Link } from 'react-router';

const QuestionBottomBar = ({ question }) => (
  <div className="ui segment right aligned grid">
    <div className="right floated ten wide column">
      <Link
        to={`/questions/${question.id}/answers/new`}
        className="ui right labeled icon button"
      >
        <i className="align left icon" />
        Ajouter une réponse
      </Link>
    </div>
  </div>
);

QuestionBottomBar.propTypes = {
  question: PropTypes.object.isRequired,
};

export default QuestionBottomBar;



// WEBPACK FOOTER //
// ./src/modules/funnel/components/detail/questions/QuestionBottomBar.js